import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Home as HomeIcon } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function NotFound() {
    useEffect(() => {
        document.title = "404 — Eclipse Cubiertas";
    }, []);

    return (
        <div
            className="min-h-screen bg-white flex items-center justify-center px-6"
            data-testid="notfound-page"
        >
            <div className="text-center max-w-md">
                <h1 className="font-display font-black text-8xl text-eclipse-cta mb-2">
                    404
                </h1>
                <p className="font-display font-bold text-2xl text-eclipse-primary mb-3">
                    Página no encontrada
                </p>
                <p className="text-eclipse-muted mb-8">
                    La página que buscas no existe o fue movida.
                </p>
                <Link to="/">
                    <Button
                        className="btn-eclipse-cta px-8 py-6 text-base"
                        data-testid="notfound-home-btn"
                    >
                        <HomeIcon className="w-5 h-5 mr-2" />
                        Volver al inicio
                    </Button>
                </Link>
            </div>
        </div>
    );
}
